const EquityDashboard = () => {
    return(
        <div>Equity Dashboard Summary Works! </div>
    )
    }
    
    export default EquityDashboard